import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import { getDocs, query, where, collection, orderBy, limit } from "firebase/firestore";
import { db } from "../firebase.js";
import Cookies from 'js-cookie';
import { Helmet } from "react-helmet";
import Lodinging from "../components_root/loading.jsx";
import Loadingimg from '../components_root/loadingimg.jsx';
import { googleLogout } from '../firebase.js';
//page links  
import { VscVmConnect, VscLock, VscCloudDownload, VscEdit, VscGistSecret, VscCallIncoming, VscLocation, VscBriefcase, VscCalendar, VscMail } from "react-icons/vsc";
import Photosicon from '../assets/photos_icon.png';
import ShareButton from '../components_root/ShareButton.jsx';

import Select_yes_no from '../components_root/select_yes_no.jsx';
import { MdAccountBox, MdArrowBackIos, MdClose, MdEdit, MdEmail, MdHistory, MdMyLocation, MdNightsStay, MdOutlineLightMode, MdSave, MdSettings, MdSupport } from 'react-icons/md';
export default function Account_profile() {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [accountname, setaccountname] = useState("");
  const [guid, setguid] = useState('');
  const [ProfileProgress, setProfileProgress] = useState(20);

  const [isLoading, setIsLoading] = useState(false);
  const [accountstatus, setAccountstatus] = useState(false);
  const [accounts_logindata, setaccounts_logindata] = useState([]);
  const popupRef = useRef(null);
  const [islogin, setIslogin] = useState(false);
  const [Selected, setSelected] = useState('Profile');
  const [accountdata, setAccountdata] = useState([]);
  
useEffect(() => {
  const existingsessiontoken = Cookies.get("sessiontoken");
  const status_user = Cookies.get("status_user");
  const guids = Cookies.get("guid");

  if (
    status_user === "login" &&
    existingsessiontoken &&
    guids
  ) {
    setguid(guids);
  } else {
    navigate("/");
  }
}, [navigate]);


  const handleGoogleLogout = async () => {
    setIsLoading(true);
    await googleLogout();
    setUser(null);
  };

  // useEffect(() => {
  //   const checkIntegration = async () => {
  //     try {
  //       const checkQuery = query(
  //         collection(db, "accounts"),
  //         where("guid", "==", guid)
  //       );

  //       const checkSnap = await getDocs(checkQuery);

  //       if (checkSnap.empty) {
      
  //         navigate('/');
  //         return;
  //       }

  //       const dataList = checkSnap.docs.map(doc => ({
  //         uid: doc.id,
  //         ...doc.data()
  //       }));

  //       setAccountdata(dataList);
  //       if (dataList.length > 0) {
  //         setAccountstatus(dataList[0].status);
  //       }

  //     } catch (err) {
  //       console.error("Error checking API integration:", err);
  //     }
  //   };

  //   if (guid) {
  //   //  checkIntegration();
  //   }
  // }, [guid, navigate]);

  // useEffect(() => {
  //   const checkIntegration = async () => {
  //     try {
  //       const checkQuery = query(
  //         collection(db, "accounts_login"),
  //         where("guid", "==", guid),
  //         orderBy("date_time", "desc"),
  //         limit(60)
  //       );

  //       const checkSnap = await getDocs(checkQuery);

  //       if (checkSnap.empty) { 
  //         return;
  //       }

  //       const dataList = checkSnap.docs.map(doc => ({
  //         uid: doc.id,
  //         ...doc.data()
  //       }));

  //       setaccounts_logindata(dataList);


  //     } catch (err) {
  //       console.error("Error checking API integration:", err);
  //     }
  //   };

  //   if (guid) {
  //    // checkIntegration();
  //   }
  // }, [guid, navigate]);

  const [darkMode, setDarkMode] = useState(false);
  useEffect(() => {
    const savedTheme = Cookies.get("theme");
    if (savedTheme === "dark") {
      setDarkMode(true);
      document.body.classList.add("dark-theme");
    }
  }, []);

  const toggleTheme = () => {
    setDarkMode((prev) => {
      const newMode = !prev;
      if (newMode) {
        document.body.classList.add("dark-theme");
        Cookies.set("theme", "dark", {
          expires: 365,
          path: "/",
          domain: ".aooz.in", // use only on live site
          secure: true
        });
      } else {
        document.body.classList.remove("dark-theme");
        Cookies.set("theme", "light", {
          expires: 365,
          path: "/",
          domain: ".aooz.in",
          secure: true
        });
      }
      return newMode;
    });
  };


  return (
    <div>


      <div className="container_roots">
        <Helmet>
          <title>btcpayai - Simplify HR, Payroll & Accounting - All in One Platform</title>

          <meta name="description" content="btcpayai is a trusted enterprise platform for managing HR, payroll, and accounting operations with simplicity and precision." />
          <meta name="keywords" content="btcpayai, HR software, payroll software, accounting software,Google cloud, enterprise HR, workforce management, employee platform, financial tools, btcpayai platform" />
          <meta name="author" content="btcpayai.com" />
          <meta name="robots" content="index, follow" />

          <meta property="og:title" content="btcpayai – HR, Payroll & Accounting Platform" />
          <meta property="og:description" content="Discover btcpayai – the all-in-one platform to manage human resources, payroll, and accounting for your business." />
          <meta property="og:type" content="website" />
          <meta property="og:url" content="https://www.btcpayai.com" />
          <meta property="og:image" content="https://www.btcpayai.com/images/btcpayai.png" />
        </Helmet>
        <div className="b-bottom">
          <table>
            <tr>
              <td ><div onClick={() => navigate(-1)}
                className="button-ui0 text-h2 bold p-2 cursor"
              >
                <MdArrowBackIos className="icon" />Account Settings
              </div></td>
              <td width={30}>
                <div
                  onClick={() => navigate(-1)}
                  className="button-ui0 p-2 cursor"
                >
                  <MdClose className="icon" />
                </div>
              </td>
            </tr>
          </table>
        </div>
        <br />
        <div className="container_size">
          <div className='post-container'>
            <div className='post_div'>
              <div className="container_size_info">
                <div className='p-11 rounded'>
                  <table className='b-bottom '>
                    <tr>
                      <td width={80}>
                        <img style={{width:"80px",height:"80px"}} className='icon_photo rounded-circle b-1' src={accountdata[0]?.photoURL || Photosicon}></img>
                      </td>
                      <td>

                        <table  >
                          <tr>

                            <td><div className='text-h1 fcap bold'>
                              {accountname || accountdata[0]?.name}
                            </div></td>
                            <td width={60}><div className='button-ui0 cursor'><MdEdit className='icon' /></div></td>
                          </tr>
                          <tr>

                            <td><div className='text-h3 fcap'>
                              {accountdata[0]?.address || "N/A"}
                            </div></td>
                            <td width={60}><div className='button-ui0 cursor'><MdEdit className='icon' /></div></td>
                          </tr>
                        </table>
                      </td>

                    </tr>
                  </table>

                  <table className='table_padding' >

                    {/* <tr>
                    <td >
                     Theme
                    </td>
                    <td>Switch between day (light) and night (dark) themes for comfortable viewing anytime.</td>
                   
<td>
  <div onClick={toggleTheme} className="button-ui">
    {darkMode ? (
      <>
        <MdOutlineLightMode className="icon" /> Day
      </>
    ) : (
      <>
        <MdNightsStay className="icon" /> Night
      </>
    )}
  </div>
</td>
                  
                  </tr> */}
                    <tr>
                      <td width={70} className='text-h3 text-off'  >
                        Mobile
                      </td>
                      <td><div className='text-h2 bold fcap'> <a> {accountdata[0]?.mobile || "N/A"}</a> </div></td>
                      <td>
                      </td>
                    </tr>
                    <tr>
                      <td width={70} className='text-h3 text-off'  >
                        Email
                      </td>
                      <td><div className='text-h2 bold fcap'> <a> {accountdata[0]?.email || ""}</a> </div></td>
                      <td>
                      </td>
                    </tr>
                    <tr>
                      <td className='text-h3 text-off' >
                        Status
                      </td>
                      <td className='text-h3'>Account status</td>
                      <td> <div className='contact-header'><b> {accountstatus === true ? <div className='bold green'>Activate</div> : <div className='bold red'>Deactivate</div>}</b> </div></td>
                      {/* <td >
                      <Select_yes_no
                        checked={accountstatus}
                        // onChange={(e) => {setAccountstatus(!accountstatus)}}
                      />
                    </td> */}
                    </tr>
                    <tr>
                      <td className='text-h3 text-off' >
                        Guid
                      </td>
                      <td><div className='contact-header'> <a> {Cookies.get("guid") || "null"}</a> </div></td>
                      <td className='text-h3' >
                        Account id
                      </td>
                    </tr>
                    <tr>
                      <td className='text-h3 text-off' >
                        Token
                      </td>
                      <td><div className='contact-header'> <a> {Cookies.get("sessiontoken") || "null"}</a> </div></td>
                      <td>
                      </td>
                    </tr>
                    <tr>
                      <td className='text-h3 text-off' >
                        City
                      </td>
                      <td><div className='text-h2 bold'>{accountdata[0]?.city || "N/A"}-{accountdata[0]?.postcode || "N/A"} </div></td>
                      <td>
                      </td>
                    </tr>
                    <tr>
                      <td className='text-h3 text-off' >
                        Reg.
                      </td>
                      <td><div className='text-h2 bold'>{accountdata[0]?.country || ""} </div></td>
                      <td>
                      </td>
                    </tr>

                    <tr>
                      <td className='text-h3 text-off' >Create</td>
                      <td>
                        {accountdata?.[0]?.date_time?.toDate?.()
                          ? accountdata[0].date_time.toDate().toLocaleString()
                          : "N/A"}
                      </td>
                      <td></td>
                    </tr> 
                    <tr> 
                      <td> <div className='text-h3 text-off'>User</div></td>
                      <td>Logout your account</td> 
                      <td width={100}>
                        <div
                          className="button-ui p-22"
                          onClick={!isLoading ? handleGoogleLogout : undefined}
                          style={{ cursor: isLoading ? 'not-allowed' : 'pointer', opacity: isLoading ? 0.6 : 1 }}
                        >
                          {isLoading ? <Loadingimg /> : <VscLock className="icon" />}
                          Logout
                        </div>
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
            </div>
            <div className='post_updates'>
              <div className="b-bottom">
                <table>
                  <tr>
                    <td ><div

                      className="button-ui0 text-h2 bold p-2"
                    >
                      <MdHistory className="icon" />Login history
                    </div></td>
                    <td width={100} ><div className='button-ui0'><MdMyLocation className='icon green' />{Cookies.get("country")}</div> </td>
                  </tr>
                </table>
              </div>
              {/* accounts_logindata */}

              <div > 
                <table className='table_padding'>
                  {accounts_logindata.map((row) => (

                    <tr key={row.id}>
                      <td width={150} ><div className='text-h4 bold'>OTP: 
                        {row.otp || "######"} - {row.login_via || ""}</div> 
                        <div className='text-h4 '>Key: {row.sessiontoken || ""}</div>
                      </td> 
                      <td  className='text-r'> 
                        <div className='text-h3 bold'>{row.name}</div>
                        <div className='text-h5'> {row.city || "N/A"}-{row.postcode || ""}, {row.state || ""}, {row.country || ""}</div> 
                        <div className='text-h4 bold text-off'> {row.date_time?.toDate?.()
                          ? row.date_time.toDate().toLocaleString()
                          : "N/A"}</div>

                      </td>
                    </tr>


                  ))}
                </table>
              </div>

            </div>
          </div>

        </div>
      </div>

    </div>

  );
}
